export default __webpack_public_path__ + "static/media/gallery-6-3.c070302c.jpg";